/**
 * Thai and English text for the driver app: a truck crew's day on the phone. Its jobs, trips and runs are TMS's and
 * keep TMS's words (`tms:`); clocking in is HR's (`hr:clock`)
 */
export const th = {
  app: { name: 'Driver', description: 'งานเหมาคันหรือรอบส่งของวันนี้ ลงเวลา ประวัติและค่าเที่ยว และถุงเงินของคนประจำรถ' },
  nav: { today: 'วันนี้', history: 'ประวัติ' },
  clock: { more: 'เวลาทำงานและขอแก้เวลา' },
  today: { run: 'รอบส่ง {{number}} · ส่งแล้ว {{done}}/{{total}}' },
  pay: {
    count: '{{count}} เที่ยว',
    estimate: 'ยอดโดยประมาณตามอัตราค่าเที่ยว ยอดที่ได้จริงดูในสลิปเงินเดือน',
    contractor: 'ค่าเที่ยวที่ตกลงไว้ในแต่ละงาน จ่ายตามรอบวางบิล',
    unrated: 'ยังไม่มีอัตรา',
  },
  history: {
    none: 'เดือนนี้ยังไม่มีงาน',
    runs: '{{count}} รอบส่ง',
    delivered: 'ส่งสำเร็จ {{count}} บิล',
    wage: 'ค่าน้ำมันโดยประมาณตามระยะทางและอัตรา ค่าแรงรายวันและยอดที่ได้จริงดูใน',
    payslips: 'สลิปเงินเดือน',
    contractor: 'ค่ารอบและค่าน้ำมันตามระยะทาง จ่ายตามรอบวางบิล',
    failed: 'ไม่สำเร็จ {{count}}',
    km: '{{km}} กม.',
    noKm: 'ยังไม่มีเลขไมล์',
  },
} as const

export const en = {
  app: {
    name: 'Driver',
    description: "The truck crew's day: today's jobs or delivery run, clocking in, history and trip pay, and the money bag",
  },
  nav: { today: 'Today', history: 'History' },
  clock: { more: 'Hours and corrections' },
  today: { run: 'Run {{number}} · delivered {{done}}/{{total}}' },
  pay: {
    count: '{{count}} trips',
    estimate: 'An estimate by the trip rates; what you are paid is on your payslip',
    contractor: "Each job's agreed pay, paid with the vendor bills",
    unrated: 'No rate yet',
  },
  history: {
    none: 'No work this month yet',
    runs: '{{count}} runs',
    delivered: '{{count}} bills delivered',
    wage: 'Fuel is an estimate by the distance and rates; your day wage and what you are paid are on',
    payslips: 'your payslips',
    contractor: 'Run pay and fuel by the distance, paid with the vendor bills',
    failed: '{{count}} not delivered',
    km: '{{km}} km',
    noKm: 'No odometer yet',
  },
}
